"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _WaterGoingModalComponent = _interopRequireDefault(require("./WaterGoingModalComponent"));
var _Modal = require("@ccw-pwa-ui/Modal");
const WaterGoingModal = _ref => {
  let {
    openWaterModal,
    positiveActionButtonTitle,
    modalHeaderText,
    learnMoreText,
    handleWaterModal,
    imageData
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "water-going-modal-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: openWaterModal,
    modalDetailText: /*#__PURE__*/_react.default.createElement(_WaterGoingModalComponent.default, {
      modalHeaderText: modalHeaderText,
      learnMoreText: learnMoreText,
      imageData: imageData
    }),
    modalHeaderIcon: false,
    displayCrossIcon: false,
    variant: "password-change-modal water-going-modal",
    positiveActionButtonTitle: positiveActionButtonTitle,
    positiveAction: () => handleWaterModal(!openWaterModal)
    // crossIconAction={() => handleWaterModal(!openWaterModal)}
  }));
};
var _default = exports.default = WaterGoingModal;